'use client';

import Error from '~/app/components/error';

export default Error;
